import "./Footer.css";
import refunnelLogo from "./assets/refunnelLogo.svg";

const Footer = () => {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer-inner">
        <div className="footer-brand-block">
          <div className="footer-kicker">
            <img src={refunnelLogo} alt="Refunnel Logo" />
            <span className="footer-kicker-text">POWERED BY REFUNNEL</span>
          </div>
          <p className="footer-headline">
            Pages like this don't run themselves.
            <br />
            Refunnel runs the creator program behind them.
          </p>
        </div>

        <a
          href="https://meetings-na2.hubspot.com/maxwell-lewis/refunnel-demo"
          target="_blank"
          rel="noreferrer"
          className="footer-cta"
        >
          <span>Book a demo</span>
          <span className="footer-cta-arrow" aria-hidden="true">
            →
          </span>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
